import { createContext } from 'react'

export interface ILinkSubcontractorContext {
  selectedMCCustomerId: string

  searchQuery: string
  setSearchQuery(value: string): void
}

export const LinkSubcontractorContext = createContext<ILinkSubcontractorContext>({
  selectedMCCustomerId: '',

  searchQuery: '',
  setSearchQuery: () => {},
})
